var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active,
      expression: "active"
    }]
  }, [_c('GGGroup', {
    attrs: {
      "order": _vm.order,
      "link": _vm.innerLink,
      "link-text": _vm.innerLinkText
    },
    on: {
      "link-click": _vm.onLinkClick
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n        " + _vm._s(_vm.name) + "\n      ")];
      },
      proxy: true
    }, _vm.factoid ? {
      key: "factoid",
      fn: function () {
        return [_c(_vm.factoid.name, _vm._b({
          tag: "component"
        }, 'component', _vm.factoidParamsParsed, false))];
      },
      proxy: true
    } : null, {
      key: "content",
      fn: function () {
        return [Array.isArray(_vm.category) ? _c('CategoryGrid', {
          attrs: {
            "list": _vm.category
          },
          on: {
            "category-click": _vm.onCategoryClick
          }
        }) : _vm._e(), _vm._v(" "), Array.isArray(_vm.brand) ? _c('BrandGrid', {
          attrs: {
            "list": _vm.brand
          },
          on: {
            "brand-click": _vm.onBrandClick
          }
        }) : _vm._e(), _vm._v(" "), Array.isArray(_vm.product) ? _c('ViewportToogle', {
          scopedSlots: _vm._u([{
            key: "desktop",
            fn: function () {
              return [_c(_vm.factoid ? 'GGShrinkGrid' : 'GGWideGrid', {
                tag: "component",
                attrs: {
                  "list": _vm.product,
                  "order": _vm.order === 'ltr' ? 'rtl' : 'ltr'
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref) {
                    var el = _ref.el,
                        size = _ref.size;
                    return [_c('GGProduct', {
                      staticStyle: {
                        "height": "100%"
                      },
                      attrs: {
                        "product": el,
                        "size": size
                      },
                      on: {
                        "link-click": _vm.onProductClick,
                        "add-to-cart": _vm.onProductAddToCart
                      }
                    })];
                  }
                }], null, false, 1941849220)
              })];
            },
            proxy: true
          }, {
            key: "mobile",
            fn: function () {
              return [_c('TSProductPromo', {
                attrs: {
                  "items": _vm.product,
                  "count": 6
                },
                on: {
                  "link-click": _vm.onProductClick
                }
              })];
            },
            proxy: true
          }], null, false, 3256051760)
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }